import VALIDATION from "constants/validationMessages";

export const formatErrors = errors =>
  errors.map(message => ({
    valid: false,
    messageLabel: VALIDATION.ALERT_LABELS.invalid,
    message,
  }));
